import type { FC } from "react";
import type { OrganicDateFilters } from "src/dashboards/organicMedia/components/Tabs/FacebookContentReport";
import PlatformAdsReport from "../platformReport/PlatformAdsReport";

const SnapchatAdsReport: FC<{ dateFilters: OrganicDateFilters }> = ({ dateFilters }) => (
  <PlatformAdsReport platform="snapchat_ads" dateFilters={dateFilters} />
);

export default SnapchatAdsReport;
